(function () {
    "use strict";
    // TODO: Use the habil-slider for the slider part of the component (see ScreeningRemark in the COL app)
    // WARNING: When reworking, take into account 'indeterminate' AND that the toggle can be disabled
    angular.module("app").component("sliderRemarkEntity", {
        template: `
            <div>
                <div class="row">
                    <div class="pull-left">
                        <label 
                            ng-style="getLabelStyle()"
                            ng-click="setValue(false)"
                            i18n="IsInvalid">
                        </label>
                        &nbsp; &nbsp;
                        <label class="switch">
                            <input type="checkbox" ng-model="remark.value" ng-disabled="$ctrl.isReadOnly || !canToggle">
                            <span class="slider round" ng-style="getSpanStyle()"></span>
                        </label>
                        &nbsp; &nbsp;
                        <label 
                            ng-style="getLabelStyle()"
                            ng-click="setValue(true)"
                            i18n="IsValid">
                        </label>
                    </div>
                    <div class="pull-right"
                         style="display: flex;
                         align-items: center;"
                         ng-if="showTextbox()">
                        <label i18n="Label_SimpleText" style="margin-top: 5px; cursor: pointer;" ng-click="remark.IsHtml = false"></label>
                        &nbsp; &nbsp;
                        <habil-switch ng-model="remark.IsHtml"></habil-switch>
                        &nbsp; &nbsp;
                        <label i18n="Label_RichText" style="margin-top: 5px; cursor: pointer;" ng-click="remark.IsHtml = true"></label>
                    </div>
                </div>
                <div class="row" style="border-top: 3px solid red;color:red;" ng-if="isIndeterminate()" i18n="Form_Error_required"></div>
                <div class="row" ng-if="showTextbox()">
                    <div ng-if="!$ctrl.isReadOnly">
                        <div class="row" ng-if="!remark.IsHtml">
                            <textarea class="form-control"
                                    rows="5" type="text"
                                    ng-model="remark.Description"
                                    style="resize: vertical;"
                                    ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" ng-change="OnTextChanged()"></textarea>
                            <div style="color:red" ng-if="!remark.Description">
                                <div style="border-top: 3px solid red" i18n="Form_Error_required"></div>
                            </div>
                        </div>
                        <div class="row" ng-if="remark.IsHtml">
                            <rich-text-editor
                                ng-model="remark.Description"
                                ng-change="OnTextChanged()"></rich-text-editor>
                            <div style="color:red" ng-if="!remark.Description">
                                <div style="border-top: 3px solid red" i18n="Form_Error_required"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row" ng-if="$ctrl.isReadOnly">
                        <pre ng-bind-html="remark.Description"></pre>
                    </div>
                </div>
            </div>
            `,
        bindings: {
            object: "=",
            isReadOnly: "=?",
            hideTextBox: "=?",
            validCode: "@",
            invalidCode: "@",
            onSet: "=?",
            collapsibleId: "@",
            setIndeterminate: "=?"
        },
        controller: sliderRemarkController
    });

    sliderRemarkController.$inject = ["$scope", "$element", "guid",];
    function sliderRemarkController($scope, element, guid) {
        const defaultLabel = { "position": "relative", "top": "5px" };
        const notAllowedCursor = { "cursor": "not-allowed" };
        const pointerCursor = { "cursor": "pointer" };

        $scope.getLabelStyle = () => vm.isReadOnly ? { ...notAllowedCursor, ...defaultLabel } : { ...pointerCursor, ...defaultLabel };
        $scope.getSpanStyle = () => vm.isReadOnly ? { ...notAllowedCursor, } : { ...pointerCursor };

        const toggle = $(element).find("input[type=checkbox]")[0];

        const vm = this;
        $scope.remark = {};
        $scope.validCode = "";
        $scope.inValidCode = "";
        $scope.canToggle = true;
        $scope.allowedSections = () => [$scope.validCode, $scope.invalidCode];
        $scope.isIndeterminate = () => $(toggle)[0].indeterminate;
        $scope.setIsIndeterminate = (indeterminate) => {
            $(toggle)[0].indeterminate = indeterminate;
            $scope.remark.indeterminate = indeterminate;
        };
        $scope.setIsIndeterminate(true);

        let saveExecutionPromise;

        vm.$onChanges = function (changes) {
            if (!changes)
                return;

            $scope.onSet = vm.onSet;
            $scope.validCode = vm.validCode;
            $scope.invalidCode = vm.invalidCode;
            $scope.collapsibleId = vm.collapsibleId;
            $scope.setIndeterminate = vm.setIndeterminate;

            $scope.remark = $scope.getRemark(vm.object.Remarks);

            $(toggle).prop("disabled", !!vm.isReadOnly);
            if (!$scope.remark.Section)
                return;

            $scope.setIsIndeterminate(false);

            const isValid = ($scope.remark.Section === $scope.validCode);
            $(toggle).prop("checked", isValid);

            $scope.remark.value = isValid;
            $scope.remark.Section = isValid ? $scope.validCode : $scope.invalidCode;

            if (isValid)
                $scope.remark.Description = null;
        };

        vm.$onInit = function () {
            $scope.determineShouldBeInvalidByDefault();
            $scope.determineShouldBeValidByDefault();
        };

        $scope.getRemark = (remarks) => {
            const setIndeterminate = angular.isDefined(vm.setIndeterminate) ? vm.setIndeterminate : true;
            const newRemark = { PublicId: guid.new(), ValidCode: $scope.validCode, InValidCode: $scope.invalidCode, indeterminate: setIndeterminate, IsHtml: false };

            $scope.setIsIndeterminate(setIndeterminate);

            if (!remarks || remarks.length === 0) {
                vm.object.Remarks = [newRemark];
                return newRemark;
            }

            const foundRemark = remarks.filter((r) => $scope.allowedSections().includes(r.Section));
            if (!foundRemark || foundRemark.length === 0) {
                vm.object.Remarks.push(newRemark);
                return newRemark;
            }
            return foundRemark[0];
        };

        $scope.determineShouldBeInvalidByDefault = () => {
            let isInvalid = (vm.object && vm.object.IVMStatus && vm.object.IVMStatus == 41 && $scope.isIndeterminate());
            /*.other rules for default value.*/
            if (isInvalid) {
                $scope.setValue(false);
                $scope.canToggle = true;
            }
        };

        $scope.determineShouldBeValidByDefault = () => {
            let isValid = (vm.object && vm.object.IVMStatus && vm.object.IVMStatus >= 60 && $scope.isIndeterminate());
            /*.other rules for default value.*/
            if (isValid) {
                $scope.setValue(true);
                $scope.canToggle = true;
            }
        };

        $scope.showTextbox = () => !vm.hideTextBox && $scope.remark.Section === $scope.invalidCode && !$scope.isIndeterminate();

        $scope.setValue = (isValid) => {
            if (vm.isReadOnly || !$scope.canToggle || $scope.remark.value === isValid)
                return;

            $(toggle).prop("checked", isValid);

            $scope.validate(isValid);
            $scope.executeOnSet(isValid);
        };

        $scope.executeOnSet = (value) => {
            if (!angular.isFunction($scope.onSet))
                return;

            if (!saveExecutionPromise) {
                saveExecutionPromise = new Promise((resolve) => {
                    $scope.onSet(value, vm.object, $scope.collapsibleId, $scope.remark);

                    resolve();
                }).then(() => { saveExecutionPromise = null; });
            }
        };

        $(toggle).change(function () {
            $scope.validate(this.checked);
            $scope.$digest();
            $scope.executeOnSet(this.checked);
        });

        $scope.validate = (isValid) => {
            $scope.setIsIndeterminate(false);
            $scope.remark.value = isValid;
            $scope.remark.Section = isValid ? $scope.validCode : $scope.invalidCode;

            if (isValid)
                $scope.remark.Description = null;
        };

        $scope.OnTextChanged = function () {
            $scope.executeOnSet($scope.remark.value);
        };

        $scope.GetStyle = () => vm.isReadOnly ? { "cursor": "not-allowed", "background-color": "rgb(119 119 119 / 35%)" } : { "cursor": "pointer" };
    };
}());